"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuperboltAbilityHandler = exports.SuperboltActorAbilityFactory = exports.SuperboltAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const core_2 = require("../../core/effects/core");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const EffectType_1 = require("../../core/effects/EffectType");
class SuperboltAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Superbolt;
        this.__typeName = "Superbolt";
    }
}
exports.SuperboltAbilityArgs = SuperboltAbilityArgs;
let SuperboltActorAbilityFactory = class SuperboltActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Superbolt", "OneEnemies", 2);
    }
};
SuperboltActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Superbolt")
], SuperboltActorAbilityFactory);
exports.SuperboltActorAbilityFactory = SuperboltActorAbilityFactory;
let SuperboltAbilityHandler = class SuperboltAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        if (container.hasAttribute(ability.invokerId, "Charm_ThunderCaller_0")
            && !container.hasEffectOfType(ability.invokerId, EffectType_1.EffectType.EchoStack)) {
            container.applyBuff({
                sequence,
                creatorId: ability.invokerId,
                targetId: ability.invokerId,
                duration: Duration_1.Duration.EndOfTurn,
                effect: new core_2.EchoStackEffectArgs(1)
            });
        }
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Focus("Nature", 70)
            ],
            onHit(sequence) {
                sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(selectedEnemy, "feet"), "LightningStrikeBeam"));
                container.applyDebuff({
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    effect: new core_2.ConvulsionsEffectArgs("Focus", 10),
                    duration: Duration_1.Duration.Ticks(16),
                    sequence: sequence.pushSequence("sequential"),
                });
            },
            onMiss(sequence) {
                sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(selectedEnemy, "random", "behind"), "LightningStrikeBeam"));
            }
        });
    }
};
SuperboltAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Superbolt)
], SuperboltAbilityHandler);
exports.SuperboltAbilityHandler = SuperboltAbilityHandler;
